(function () {
  'use strict';

  const BACKEND_URL = window.minicoinBackendUrl || '';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const PHONE_RE = /^[6-9]\d{9}$/;

  const overlay = document.getElementById('minicoin-details-overlay');
  const dialog = overlay ? overlay.querySelector('.mc-details-popup') : null;
  const form = document.getElementById('mc-details-form');
  const nameInput = document.getElementById('mc-details-name');
  const phoneInput = document.getElementById('mc-details-phone');
  const emailInput = document.getElementById('mc-details-email');
  const errorBox = document.getElementById('mc-details-error');
  const submitBtn = document.getElementById('mc-details-submit');
  const amountEl = document.getElementById('mc-details-amount');

  if (!overlay || !form) return;

  let onSuccess = null;
  let referralCode = null;

  function showError(msg) {
    errorBox.textContent = msg;
    errorBox.classList.add('is-visible');
  }
  function clearError() {
    errorBox.textContent = '';
    errorBox.classList.remove('is-visible');
  }
  function setLoading(loading) {
    submitBtn.disabled = loading;
    submitBtn.textContent = loading ? 'Saving…' : 'Unlock my Minicoins';
  }

  function open(opts) {
    opts = opts || {};
    onSuccess = typeof opts.onSuccess === 'function' ? opts.onSuccess : null;
    referralCode = opts.referralCode || null; // credited server-side after the customer is created
    amountEl.textContent = Number(opts.bonusAmount || opts.amount || 500).toLocaleString('en-IN');
    clearError();
    setLoading(false);
    // Prefill the first name if KwikPass gave us one.
    try {
      const cached = window.MinitureIdentity && window.MinitureIdentity._readCache && window.MinitureIdentity._readCache();
      if (cached && cached.first_name && !nameInput.value) nameInput.value = cached.first_name;
    } catch (e) { /* ignore */ }

    overlay.classList.add('active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    // Focus the first empty field.
    setTimeout(function () { (nameInput.value ? phoneInput : nameInput).focus(); }, 60);
  }

  function close() {
    overlay.classList.remove('active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  async function submit(e) {
    e.preventDefault();
    clearError();

    const id = window.MinitureIdentity;
    const identity = id && id.getIdentity && id.getIdentity();
    const identityType = (id && id.getIdentityType && id.getIdentityType()) || 'shopify_id';
    const signature = id && id.getSignature && id.getSignature();
    if (!identity || !signature) {
      showError('Please sign in again to continue.');
      return;
    }

    const name = nameInput.value.trim();
    const email = emailInput.value.trim();
    const phone = phoneInput.value.replace(/\D/g, '');

    if (!name) return showError('Please enter your name.');
    if (!PHONE_RE.test(phone)) return showError('Please enter a valid 10-digit mobile number.');
    if (!EMAIL_RE.test(email)) return showError('Please enter a valid email address.');

    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/v1/v2/minicoins/register-customer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Minicoin-Signature': signature },
        body: JSON.stringify({ identity: identity, identity_type: identityType, name: name, email: email, phone: phone, code: referralCode || undefined }),
      });
      const result = await response.json().catch(function () { return {}; });

      if (!response.ok || result.error) {
        showError((result && result.error && result.error.message) || 'Something went wrong. Please try again.');
        setLoading(false);
        return;
      }

      const data = result.data || {};

      // Cache the fresh code (full shape, matching minicoin-checkout-sync) so the
      // cart + dashboard surface it immediately, and prime Shopify's discount
      // cookie so it applies at checkout. Never displaces a pending marketing code.
      if (data.code) {
        try {
          sessionStorage.setItem('miniture_checkout_discount', JSON.stringify({
            identity: identity, code: data.code, amount: data.amount || 0, order_wide: !!data.order_wide, at: Date.now(),
          }));
        } catch (e) { /* ignore */ }
        if (!/(?:^|;\s*)discount_code=[^;]+/.test(document.cookie)) {
          fetch('/discount/' + encodeURIComponent(data.code), { credentials: 'same-origin' }).catch(function () {});
        }
      }

      window.dispatchEvent(new CustomEvent('miniture:minicoin_updated', {
        detail: { code: data.code || null, amount: data.amount || 0, order_wide: !!data.order_wide },
      }));
      var toastMsg = data.coupon_pending
        ? 'Account set up — your coupon will appear here shortly'
        : 'Account set up!';
      if (window.showToast) window.showToast(toastMsg, 'success');
      close();
      // The caller finishes the flow (e.g. credits the referral, then mints the
      // coupon). Runs after close so the credit lands on a real, registered profile.
      if (onSuccess) { try { await onSuccess(data); } catch (e) { /* ignore */ } }
    } catch (err) {
      showError('Network error. Please try again.');
      setLoading(false);
    }
  }

  form.addEventListener('submit', submit);
  // Restrict the phone field to digits as the user types.
  phoneInput.addEventListener('input', function () {
    this.value = this.value.replace(/\D/g, '').slice(0, 10);
  });
  // Dismiss on overlay click (but not clicks inside the dialog) and ESC.
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('active')) close(); });

  window.showMinicoinDetailsPopup = open;
  window.closeMinicoinDetailsPopup = close;
})();
